import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        toast.error('Google sign-in failed — no session received.');
        navigate('/auth', { replace: true });
        return;
      }

      const sessionId = match[1];

      try {
        const res = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId,
        });
        const { access_token, user } = res.data;
        localStorage.setItem('token', access_token);
        useAuthStore.setState({ token: access_token, user, loading: false });
        navigate('/dashboard', { replace: true });
      } catch (err) {
        const msg = err.response?.data?.detail || 'Google sign-in failed. Please try again.';
        toast.error(msg);
        navigate('/auth', { replace: true });
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen" data-testid="auth-callback-spinner">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1d4ed8] mx-auto" />
        <p className="mt-4 text-[#475569]">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
